import InfoBoxController from './info.controller';

import {} from './info.styles.scss';

export default angular.module('directives.infoBox', [])
  .directive('infoBox', () => {
    'ngInject';

    return {
      controller: InfoBoxController,
      restrict: 'E',
      transclude: true,
      scope: {},
      templateUrl: require('./info.template.html'),
    };
  })
  .name;
